// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gank-loader--full{width:100vw}.loader{height:calc(100vh - 153px)}.loading-logo{width:100px;height:100px}@media screen and (max-width:540px){.loader{height:calc(100vh - 293px)}}@media screen and (min-width:768px){.loader{height:calc(100vh - 303px)}.loading-logo{width:200px;height:200px}}@media screen and (min-width:1024px){.loader{height:calc(100vh - 183px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
